export default [
	'Miracle System',
	'Permanent Colour',
	'Gloss',
	'Shampoo & Conditioner',
	'Root',
	'Miracle Mask',
	'Blending Brush'
]